import Seo from "@/components/Seo";

export default function Terms() {
    return (
        <>
            <Seo
                title="Terms of Use — FinCalc"
                description="Terms of use for FinCalc's free finance calculators. No financial advice. Use at your own risk."
                canonical="/terms"
            />
            <section className="container-editorial py-16 max-w-3xl">
                <div className="text-[11px] uppercase tracking-[0.2em] text-accent">Legal</div>
                <h1 className="font-serif text-5xl text-primary mt-3">Terms of Use</h1>
                <p className="mt-2 text-sm text-muted-foreground">Last updated: February 2026</p>
                <div className="mt-8 prose-editorial">
                    <h2>Acceptance</h2>
                    <p>
                        By accessing or using FinCalc, you agree to these Terms. If you do not
                        agree, please do not use the site.
                    </p>
                    <h2>Not financial advice</h2>
                    <p>
                        The calculators and content on FinCalc are for informational and
                        educational purposes only. Nothing on FinCalc constitutes financial,
                        investment, legal, or tax advice. Always consult a qualified licensed
                        professional before making any financial decision.
                    </p>
                    <h2>No warranty</h2>
                    <p>
                        While we work hard to keep calculations accurate and assumptions current,
                        we make no warranty that the results will be error-free or applicable to
                        your specific situation. FinCalc is provided &ldquo;as is&rdquo; without
                        warranties of any kind.
                    </p>
                    <h2>Limitation of liability</h2>
                    <p>
                        To the maximum extent permitted by law, FinCalc and its operators shall
                        not be liable for any direct, indirect, incidental, or consequential
                        damages arising from your use of the site or reliance on any calculation.
                    </p>
                    <h2>Third-party links and ads</h2>
                    <p>
                        FinCalc may display advertising served by third parties. We are not
                        responsible for the content, accuracy, or practices of any linked or
                        advertised third party.
                    </p>
                    <h2>Intellectual property</h2>
                    <p>
                        All content, calculator logic, and branding on FinCalc are the property
                        of FinCalc unless otherwise noted. You may link to the site freely.
                    </p>
                    <h2>Changes</h2>
                    <p>
                        We may update these Terms from time to time. Continued use of the site
                        after changes constitutes acceptance of the revised Terms.
                    </p>
                </div>
            </section>
        </>
    );
}
